export function updateGA(id) {
  if (typeof gtag === 'function') {
    const title = document.title;
    const url = window.location.pathname + window.location.search;
    // const gaId = this.options.gaMeasurementId;
    const gaId = id

    if (!gaId) {
      throw new Error('gaMeasurementId option is required for gtag.');
    }

    window.gtag('config', gaId, {
      page_title: title,
      page_path: url
    });

    console.log(`GTAG pageview (url '${url}').`);

  } else if (typeof window.ga === 'function') {
    const title = document.title;
    const url = window.location.pathname + window.location.search;

    window.ga('set', 'title', title);
    window.ga('set', 'page', url);
    window.ga('send', 'pageview');

    console.log(`GA pageview (url '${url}').`);

  } else {
    console.warn("window.gtag and window.ga don't exists.");
  }
}

export function updateGTM() {
  if (typeof window.dataLayer === 'object') {
      const object = {
          'event': 'VirtualPageview',
          'virtualPageURL': window.location.pathname + window.location.search,
          'virtualPageTitle': document.title
      };

      window.dataLayer.push(object);

      console.log(`GTM pageview (url '${object.virtualPageURL}').`);
  } else {
      console.warn('GTM is not loaded.')
  }
}